import axios from "axios";

// Libs
import {getTokenFromLocalStorage} from "../auth/auth";
import utilsLib from "../common/libs/utils-lib";

// Constants
export const FETCH_INVOICES_REQUEST = "FETCH_INVOICES_REQUEST";
export const FETCH_INVOICES_SUCCESS = "FETCH_INVOICES_SUCCESS";
export const FETCH_INVOICES_ERROR = "FETCH_INVOICES_ERROR";
export const CLEAN_INVOICES_STATE = "CLEAN_INVOICES_STATE";

export const readInvoices = (filters = {}) => {
    return async (dispatch) => {
        try {
            dispatch(fetchInvoicesRequest());

            const token = getTokenFromLocalStorage();

            const res = await axios.post('/api/invoices', {filters}, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, fetchInvoicesSuccess, fetchInvoicesError));
        } catch (err) {
            dispatch(utilsLib.response(err, fetchInvoicesError));
        }
    };
};

const fetchInvoicesRequest = () => {
    return {
        type: FETCH_INVOICES_REQUEST
    };
};

const fetchInvoicesSuccess = (payload) => {
    return {
        type: FETCH_INVOICES_SUCCESS,
        payload
    };
};

const fetchInvoicesError = (errorMessage) => {
    return {
        type: FETCH_INVOICES_ERROR,
        errorMessage
    };
};

export const cleanInvoicesState = () => {
    return {
        type: CLEAN_INVOICES_STATE
    }
}